import { BuyPlanPageContextProps } from './BuyPlanPageContextProps'
import { createContext } from 'react'

export const BuyPlanPageContext = createContext<BuyPlanPageContextProps | undefined>(undefined)
